import { Component, input, NgZone, OnInit } from "@angular/core";
import { animationFrameScheduler, interval, Observable, race, Subject, takeUntil, timer } from "rxjs";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'rsr-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
  standalone: true,
  imports: [MatIcon]
})
export class LoadingComponent implements OnInit {
  text = input('Loading...');
  loaded = input(false);
  animateFor = input<number>();

  private readonly _destroyed$ = new Subject<void>();
  private animationId  = 0;
  private xPosMax = 100;

  public xPos = 0;

  constructor(private ngZone: NgZone) {
  }

  ngOnInit(): void {
    const TIME_OFFSET = 1000;

    let stopLoading$: Observable<number | void>;
    const runFor = this.animateFor();

    if (runFor && runFor > 0) {
      // We need to make sure to unsubscribe when either the timer is done or the component is unmounted
      stopLoading$ = race(
        timer(runFor + TIME_OFFSET), // the interval starts with a delay already
        this._destroyed$
      );
    } else {
      stopLoading$ = this._destroyed$;
    }

    interval(10, animationFrameScheduler)
      .pipe(takeUntil(stopLoading$))
      .subscribe(val => {
        this.updateIndicator(val);
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }

  private updateIndicator(value: number): void {
    this.animationId = this.ngZone.runOutsideAngular(() =>
      requestAnimationFrame(() => {
        const xPos = value < this.xPosMax ? value : value % this.xPosMax;
        this.xPos = xPos;
      })
    );
  }
}
